import { create as createConfig, TSingleCatalogConfig } from '../models/SingleCatalogConfig'
import { create as createItem, TSingleCatalogItem } from '../models/SingleCatalogItem'
import { AbstractCatalogStore } from './AbstractCatalogStore'

export class SingleCatalogStore extends AbstractCatalogStore<TSingleCatalogConfig, TSingleCatalogItem>{
  public constructor() {
    super({ createConfig, createItem })
  }
}
